import useGetApi from 'src/api/useGetApi';
import CurrentUser from 'src/types/CurrentUser';

interface Response {
  user: CurrentUser | null;
}

const useCurrentUser = () => {
  return useGetApi<Response>({
    endpoint: 'auth/me',
  });
};

export default useCurrentUser;
